import { useEffect } from 'react';

import ModalsContainer from '@components/modals/modals-container';
import { VerktoyDetailsPageWrapper } from '@components/verktoy-details/verktoy-details-page-wrapper';
import { useBreadcrumb } from '@hooks/useBreadcrumb';
import { useGetResources } from '@hooks/useGetResources';
import { useAppDispatch, useAppSelector } from '@store';
import { fetchMineVerktoyV2Thunk, fetchVerktoyThunk } from '@store/verktoy/thunks';
import { getOppgaveFlowState } from '@utils/oppgave-flow-utils';
import { getErrorLabel, hasPageHeader } from '@utils/verktoyContainer-utils';
import { useLocation, useParams } from 'react-router';

import Loader from '@helsenorge/designsystem-react/components/Loader';

import PageLoader from '@helsenorge/core-framework/page-loader';
import PageRoot from '@helsenorge/core-framework/pageroot';
import { isAuthorized } from '@helsenorge/framework-utils/hn-authorize';
import { getPath } from '@helsenorge/framework-utils/hn-page';

export const VerktoyDetailsContainer = (): React.JSX.Element | null => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { verktoyId } = useParams();
  const resources = useGetResources();
  const breadcrumbLink = useBreadcrumb();
  const error = useAppSelector(state => state.verktoy.error);
  const isWaitingForAktivitetResponse = useAppSelector(state => state.verktoy.isWaitingForAktivitetResponse);
  const verktoyLoading = useAppSelector(state => state.verktoy.verktoyLoading);
  const verktoy = useAppSelector(state => state.verktoy.verktoy);
  const isLoggedIn = isAuthorized();
  const fullPath = `/${getPath()}${location.pathname}`;
  const oppgaveFlow = getOppgaveFlowState();

  useEffect(() => {
    if (verktoyId) {
      dispatch(fetchVerktoyThunk({ isLoggedIn, verktoyId, oppgaveId: oppgaveFlow.oppgaveId }));

      if (isLoggedIn) {
        dispatch(fetchMineVerktoyV2Thunk());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verktoyId]);

  if (!resources) {
    return null;
  }
  return (
    <PageRoot
      hasPageHeader={hasPageHeader(location.pathname)}
      pageTitle={resources.entryPage_header}
      breadcrumbLink={breadcrumbLink}
      redirectTo={fullPath}
      enablePageviewTracking
      enableSurveys
    >
      <div className="verktoy__wrapper">
        <PageLoader inline resources={resources} error={error ? getErrorLabel(resources, error, location.pathname) : undefined}>
          {isWaitingForAktivitetResponse && <Loader />}
          <ModalsContainer />
          <VerktoyDetailsPageWrapper verktoyLoading={verktoyLoading} verktoy={verktoy} />
        </PageLoader>
      </div>
    </PageRoot>
  );
};
